import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import ReusableButton from '../../SharedComponents/Button/Button'
import ReusableTextBox from '../../SharedComponents/Textbox/Textbox'
import CoopDashboardLoginLogo from '../../Images/coopLogoDashboard.png'
import Loading from '../../Images/loading.gif'
import DashboardLogo from '../../SharedComponents/DashboardLogo/DashboardLogo'
import $ from "jquery"
import '../../CSS/global.css'
import './CleanerDashboardSignUp.css'
import { destroySession } from '../../Utility/Utility';
import { GetDomainDropDown } from '../../CleanersDashboardAPI/CleanersDashboardDropDownAPi'
import { UserRegister } from '../../CleanersDashboardAPI/CleanersDashboardUserRegisterAPi'
import { VendorValidateSignUpOTP } from '../../CleanersDashboardAPI/CleanersDashboardValidateSignUpAPi'
import * as CleanerDashboardSignUpConstant from './CleanerDashboardSignUpConstant'
import Select from 'react-select'
import Modal from 'react-modal';
import { IoIosClose } from "react-icons/io";
import { IconContext } from "react-icons";
import GreenTick from '../../Images/tick-round.png'
import bcrypt from 'bcryptjs';



class CleanerDashboardSignUp extends Component {
    constructor(props) {
        super(props)
        this.state = {
            UserName: '',
            loading: false,
            UserId: '',
            Password: "",
            RePassword: '',
            FirstName: '',
            LastName: '',
            VendorName: '',
            EmailAddress: '',
            redirectCleanersDashboard: false,
            redirectLogin: false,
            elementIDFirstName: false,
            elementIDLastName: false,
            elementIDUserName: false,
            elementIDVendorName: false,
            elementIDRePwd: false,
            elementIDPwd: false,
            errors: {},
            errorsFirstName: '',
            errorsLastName: '',
            errorsEmail: '',
            errorsVendor: '',
            errorsUserName: '',
            errorsPwd: '',
            errorsRePwd: '',
            arrayDomains: [],
            errorsPasswordMismatch: '',
            selectedOption: null,
            selectedDomain: "",
            redirectSuccessSignUp: false,
            modalIsOpen: false,
            modalSucessIsOpen : false,
            errorsPwdPolicy: '',
            openAuthenticateScreen : false,
            elementOTP: false,
            OTP:"",
            errorsOTP : ""

        }

        this.handleChangeFirstName = this.handleChangeFirstName.bind(this);
        this.handleChangeLastName = this.handleChangeLastName.bind(this);
        this.handleChangeUserName = this.handleChangeUserName.bind(this);
        this.handleChangeDomain = this.handleChangeDomain.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handlePwd = this.handlePwd.bind(this);
        this.handleRePwd = this.handleRePwd.bind(this);
        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.openModalSuccess = this.openModalSuccess.bind(this);
        this.afterOpenModalSucess = this.afterOpenModalSucess.bind(this);
        this.closeModalSucess = this.closeModalSucess.bind(this);
         this.handleSuccessOk =this.handleSuccessOk.bind(this);
    }
    componentWillMount() {
        this.setState({
            loading: true
        })
        GetDomainDropDown().then(res => {
            let responseJSON = res
            let arraySuppliername = []
            let arrayDomains=[]
            if (responseJSON.status === 200) {
                let arrayDomainsResponse = responseJSON.data.domainName
                Object.keys(arrayDomainsResponse).forEach(function (key) {
                    arrayDomains.push({
                        label: arrayDomainsResponse[key],
                        value: arrayDomainsResponse[key]
                    })
                })
                this.setState({
                    loading: false,
                    arrayDomains: arrayDomains
                })
            }
            else if (responseJSON.status === 404) {
                // this.state({
                //     isUserValid : false,
                //     loading : false
                // }) 
            }
        })

    }
    handleSuccessOk = (e) => {
        this.setState({
            openAuthenticateScreen : true,
            modalIsOpen : false
        })
    }
    openModal() {
        this.setState({ modalIsOpen: true });
    }

    afterOpenModal() {
    }

    closeModal() {
        this.setState({
            modalIsOpen: false,
            redirectLogin: true
        });
    }
    openModalSuccess() {
        this.setState({ modalSucessIsOpen: true });
    }

    afterOpenModalSucess() {
    }

    closeModalSucess() {
        this.setState({
            modalSucessIsOpen: false,
            redirectLogin: true
        });
    }
    handleChangeFirstName = (e) => {
        this.setState({
            FirstName: e.target.value
        })
    }
    handleChangeLastName = (e) => {
        this.setState({
            LastName: e.target.value

        })
    }
    handleChangeUserName = (e) => {
        this.setState({
            UserName: e.target.value,
            // elementIDVendorName: false
        })
    }
    handleChangeDomain = selectedOption => {
        this.setState(
            {
                selectedOption: selectedOption,
                selectedDomain: selectedOption.label,
                elementIDVendorName: false,
            });
    };
    handlePwd = (e) => {
        this.setState({
            Password: e.target.value
        })
    }
    handleRePwd = (e) => {
        this.setState({
            RePassword: e.target.value
        })
    }
    handleCancel = (e) => {
        this.setState({
            redirectLogin: true
        })
    }
    onKeyPress = e => {
        if (this.state.FirstName.length < 0) {
            this.setState({
                elementIDFirstName: true
            });
        }
        else {
            this.setState({
                elementIDFirstName: false
            });
        }
    };
    onKeyPressPwd = e => {
        if (this.state.Password.length < 0) {
            this.setState({
                elementIDPwd: true
            });
        }
        else {
            this.setState({
                elementIDPwd: false
            });
        }
    };
    onKeyPressRePwd = e => {
        if (this.state.RePassword.length < 0) {
            this.setState({
                elementIDRePwd: true
            });
        }
        else {
            this.setState({
                elementIDRePwd: false
            });
        }
    };
    onKeyPressUser = e => {
        if (this.state.UserName.length < 0) {
            this.setState({
                elementIDUserName: true
            });
        }
        else {
            this.setState({
                elementIDUserName: false
            });
        }
    };
    onKeyPressLast = e => {
        if (this.state.LastName.length < 0) {
            this.setState({
                elementIDLastName: true
            });
        }
        else {
            this.setState({
                elementIDLastName: false
            });
        }
    };
    onKeyPressOTP(e) {
        var regex = /[0-9]{1,6}/
        var key = String.fromCharCode(!e.charCode ? e.which : e.charCode);
        var Cond = regex.test(key)
        if (Cond) {
            if (this.state.OTP.length < 0) {
                this.setState({
                    elementOTP: true
                });
            }
            else {
                this.setState({
                    elementOTP: false
                });
            }
        }
        else {
            e.preventDefault();
            return false;
        }
    }
    handleAuthenticate = (e) => {
        this.setState({
            loading : true
        })
        let AuthData = {
            OTP: this.state.OTP,
            UserEmail : this.state.UserName + "@" + this.state.selectedDomain
        }
        if (AuthData.OTP == "") {
            let errorsOTP = ''
            errorsOTP = CleanerDashboardSignUpConstant.emptyOTP
            this.setState({
                elementOTP: true,
                errorsOTP: errorsOTP,
                loading: false
            })
        }
        else {
            VendorValidateSignUpOTP(AuthData).then(res => {
                if (res.data.description == "Invalid User Data") { /* Backend Custom Error for Invalid Passcode or OTP*/
                    let errorsOTP = ''
                    errorsOTP = CleanerDashboardSignUpConstant.emptyInvalidPasscode
                    this.setState({
                        elementOTP: true,
                        errorsOTP: errorsOTP,
                        loading: false
                    })
                }
                if (res.data.description == "Token Expired") { /* Backend Custom Error for OTP Expire*/
                    let errorsOTP = ''
                    errorsOTP = CleanerDashboardSignUpConstant.TokenExpire
                    this.setState({
                        elementOTP: true,
                        errorsOTP: errorsOTP,
                        loading: false
                    })
                }
                if(res.status == 200) {
                   this.setState({
                       loading : false
                   })
                   this.openModalSuccess();
                }
            })
        }
       
    }
    handleCancelAuthenticate = (e) => {
        this.setState({
            redirectLogin : true
        })
    }
    handleOTP = (evt) => {
        this.setState({
            OTP: evt.target.value
        })
    }
    handleSubmit = (e) => {
        var Regex = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/
        var Cond = Regex.test(this.state.Password);
        var apiFlag = true
        var HidePwdPolicy = false
        var PwdMisMatch = false
        let AuthData = {
            FirstName: this.state.FirstName,
            LastName: this.state.LastName,
            Email: this.state.UserName + "@" + this.state.selectedDomain,
            Password: this.state.Password,
            RePassword: this.state.RePassword,
        }
        if ((AuthData.Password) == (AuthData.RePassword)) {
            if (AuthData.FirstName == "") {
                let errorsFirstName = ''
                errorsFirstName = CleanerDashboardSignUpConstant.emptyFirstName
                this.setState({
                    elementIDFirstName: true,
                    errorsFirstName: errorsFirstName
                })
                apiFlag = false
            }

            if (AuthData.LastName == "") {
                let errorsLastName = ''
                errorsLastName = CleanerDashboardSignUpConstant.emptyLastName
                this.setState({
                    elementIDLastName: true,
                    errorsLastName: errorsLastName
                })
                apiFlag = false
            }
            if (this.state.UserName == "") {
                let errorsUserName = ''
                errorsUserName = CleanerDashboardSignUpConstant.emptyUserName
                this.setState({
                    elementIDUserName: true,
                    errorsUserName: errorsUserName
                })
                apiFlag = false
            }
            if (this.state.selectedDomain == "") {
                let errorsVendor = ''
                errorsVendor = CleanerDashboardSignUpConstant.emptyVendorName
                this.setState({
                    elementIDVendorName: true,
                    errorsVendor: errorsVendor
                })
                apiFlag = false
            }
            if (AuthData.Password == "") {
                let errorsPwd = ''
                errorsPwd = CleanerDashboardSignUpConstant.emptyPassword
                this.setState({
                    elementIDPwd: true,
                    errorsPwd: errorsPwd,
                })
                apiFlag = false
                HidePwdPolicy = true
            }

            if (AuthData.RePassword == "") {
                let errorsRePwd = ''
                errorsRePwd = CleanerDashboardSignUpConstant.emptyRePassword
                this.setState({
                    elementIDRePwd: true,
                    errorsRePwd: errorsRePwd
                })
                apiFlag = false
            }
            if (!(Cond)) {
                let errorsPwdPolicy = ''
                errorsPwdPolicy = CleanerDashboardSignUpConstant.emptyPasswordPolicy
                this.setState({
                    elementIDPwdPolicy: true,
                    errorsPwdPolicy: errorsPwdPolicy,
                    elementIDPassword: false
                })
                apiFlag = false
            }

            if ((HidePwdPolicy)) {
                this.setState({
                    elementIDPwdPolicy: false,
                    elementIDPassword: false
                })
            }
            if (apiFlag) {
                let AuthDataAPI = {
                    FirstName: this.state.FirstName,
                    LastName: this.state.LastName,
                    Email: this.state.UserName + "@" + this.state.selectedDomain,
                    Password: this.state.Password,
                }
                this.setState({
                    loading: true,
                    elementIDPassword: false,
                    elementIDRePassword: false
                })
                bcrypt.genSalt(10, (err, salt) => {
                    bcrypt.hash(AuthDataAPI.Password, salt, (err, hash) => {
                             AuthDataAPI.Password = hash
                             UserRegister(AuthDataAPI).then(res => {
                                let responseJSON = res;
                                if (responseJSON.status === 200) {
                                    this.setState({
                                        loading: false,
                                    })
                                    this.openModal();
                                }
                                else if (responseJSON.status === 404) {
                                    if (responseJSON.data.description == "User Exists") { /* Backend Custom Error for User Exists*/
                                        let errorsUserName = ''
                                        errorsUserName = CleanerDashboardSignUpConstant.UserExists
                                        this.setState({
                                            elementIDUserName: true,
                                            errorsUserName: errorsUserName,
                                            loading: false
                                        })
                                    }
                                }
                            })
                        //   bcrypt.compare(AuthData.Password, hash, function(err, res) {
                        // });
                    });
                });
            }
        }
        else {
            let errorsPasswordMismatch = ''
            errorsPasswordMismatch = CleanerDashboardSignUpConstant.emptyPasswordMismatch
            this.setState({
                elementIDPassword: true,
                elementIDRePassword: true,
                elementIDPwdPolicy: false,
                errorsPasswordMismatch: errorsPasswordMismatch,
                elementIDPwd: false
            })
        }
    }

    render() {
        const { selectedOption } = this.state;
        if (this.state.redirectLogin) {
            return (<Redirect to={'/DashboardLogin'} />)
        }
        return (
            <div>
                {this.state.loading ?
                    <div className="overlay"><img src={Loading} alt="Loading" className="loadingSignOut" /></div> : null}
                <div className="DashboardLoginRootDivSignUp" id="rootDiv">
                    <div className="DashboardLoginDivHeaderSignUp">
                        <DashboardLogo />
                        <h2>{CleanerDashboardSignUpConstant.visit}</h2>
                        <p>{CleanerDashboardSignUpConstant.cleaning}</p>
                    </div>
                    {this.state.openAuthenticateScreen ? null : 
                    <div id="UsernameField">
                        <div className="DashboardLoginDivHeaderSignIn">
                            <h1>{CleanerDashboardSignUpConstant.NewUser}</h1>
                            <p>{CleanerDashboardSignUpConstant.Visitors}</p>
                            <p class="requiredMandatory">{CleanerDashboardSignUpConstant.Mandatory}</p>
                            <p class="required">{CleanerDashboardSignUpConstant.FirstName}</p>
                            {this.state.elementIDFirstName ? <span className="errorEmail">{this.state.errorsFirstName}</span> : null}
                            <ReusableTextBox className="SignInField" type="text" onChange={this.handleChangeFirstName} onKeyPress={button => this.onKeyPress(button)} />
                            <p class="required">{CleanerDashboardSignUpConstant.LastName}</p>
                            {this.state.elementIDLastName ? <span className="errorEmail">{this.state.errorsLastName}</span> : null}
                            <ReusableTextBox className="SignInField" type="text" onChange={this.handleChangeLastName} onKeyPress={button => this.onKeyPressLast(button)} />
                            <div className="displayFlex">
                                <p class="required">{CleanerDashboardSignUpConstant.UserName}</p>
                                <p class="requiredDomain">{CleanerDashboardSignUpConstant.Domain}</p>
                                <span className="mandatoryDomainField">*</span>
                            </div>
                            
                            {this.state.elementIDUserName ? <span className="errorEmail">{this.state.errorsUserName}</span> : null}
                            {this.state.elementIDVendorName ? <span className="errorEmailSelect">{this.state.errorsVendor}</span> : null}
                            <div className="displayFlex">
                                <ReusableTextBox className="SignInFieldEmail" type="text" onChange={this.handleChangeUserName} onKeyPress={button => this.onKeyPressUser(button)} />
                                <div className="atTheRate">@</div>
                                <Select
                                    value={selectedOption}
                                    options={this.state.arrayDomains}
                                    onChange={e => this.handleChangeDomain(e)}
                                    className="LoadingSelect"
                                //   menuIsOpen={false}
                                />
                                {/* <select className="SignInField"  onChange={this.handleChangeDomain} id="dropdown" >
                                    {this.state.arrayDomains.map((e, key) => {
                                        return <option key={key} value={e.domain[0]} >{e.domain}</option>;
                                    })}
                                </select> */}
                            </div>
                            <p class="required">{CleanerDashboardSignUpConstant.Password}</p>
                            {this.state.elementIDPwd ? <span className="errorEmail">{this.state.errorsPwd}</span> : null}
                            {this.state.elementIDPassword && this.state.elementIDRePassword ? <span className="errorEmail">{this.state.errorsPasswordMismatch}</span> : null}
                            {this.state.elementIDPwdPolicy ? <span className="errorEmail">{this.state.errorsPwdPolicy}</span> : null}
                            <ReusableTextBox className="PwdSignUpField" onChange={this.handlePwd} onKeyPress={button => this.onKeyPressPwd(button)} type="password" />
                            <div className="Password">
                                <span className="PwdPolicy">{CleanerDashboardSignUpConstant.PasswordPolicy1}</span><br />
                                <span className="PwdPolicy">{CleanerDashboardSignUpConstant.PasswordPolicy2}</span>
                            </div>
                            <p class="required">{CleanerDashboardSignUpConstant.RetypePassword}</p>
                            {this.state.elementIDRePwd ? <span className="errorEmail">{this.state.errorsRePwd}</span> : null}
                            {this.state.elementIDPassword && this.state.elementIDRePassword ? <span className="errorEmail">{this.state.errorsPasswordMismatch}</span> : null}
                            <ReusableTextBox className="PwdSignUpField" onChange={this.handleRePwd} onKeyPress={button => this.onKeyPressRePwd(button)} type="password" />
                            <div className="ForgotButtons">
                                <ReusableButton onClick={this.handleSubmit} buttonText={CleanerDashboardSignUpConstant.Submit} className="SubmitField" />
                                <ReusableButton onClick={this.handleCancel} buttonText={CleanerDashboardSignUpConstant.Cancel} className="CancelField" />
                            </div>
                            <Modal
                                isOpen={this.state.modalIsOpen}
                                onAfterOpen={this.afterOpenModal}
                                onRequestClose={this.closeModal}
                                className="Modal"
                                contentLabel="Example Modal"
                                ariaHideApp={false}
                            >
                                <IconContext.Provider
                                    value={{ color: 'grey', className: "global-class-name" }}
                                >
                                    <IoIosClose onClick={this.closeModal} />
                                </IconContext.Provider>
                                <img src={GreenTick} className="SuccessTick" />
                                <div className="ModalContent">
                                    <p className="boldContent">{CleanerDashboardSignUpConstant.Success}</p>
                                </div>
                                <p className="ModalP">{CleanerDashboardSignUpConstant.Authentication}</p>
                                {/* <p className="ModalP">{CleanerDashboardSignUpConstant.ThankYou}</p>
                                <p className="ModalP">{CleanerDashboardSignUpConstant.Registered}</p> */}
                                 <ReusableButton className="CancelFieldModal" buttonText="Ok" onClick={this.handleSuccessOk} />
                                {/* <ReusableButton className="CancelFieldModal" buttonText="Ok" onClick={this.handleSuccessOk} /> */}
                            </Modal>
                        </div>
                    </div> }
                 {/* Modal for SignUp Sucess*/}
                 <Modal
                                isOpen={this.state.modalSucessIsOpen}
                                onAfterOpen={this.afterOpenModalSucess}
                                onRequestClose={this.closeModalSucess}
                                className="Modal"
                                contentLabel="Example Modal"
                                ariaHideApp={false}
                            >
                                <IconContext.Provider
                                    value={{ color: 'grey', className: "global-class-name" }}
                                >
                                    <IoIosClose onClick={this.closeModalSucess} />
                                </IconContext.Provider>
                                <img src={GreenTick} className="SuccessTick" />
                                <div className="ModalContent">
                                    <p className="boldContent">{CleanerDashboardSignUpConstant.Success}</p>
                                </div>
                                <p className="ModalP">{CleanerDashboardSignUpConstant.ThankYou}</p>
                                <p className="ModalP">{CleanerDashboardSignUpConstant.Registered}</p>
                            </Modal>
                    {this.state.openAuthenticateScreen ? 
                            <div id="UsernameField">
                                <div className="DashboardLoginDivHeaderSignIn">
                                    <h1>{CleanerDashboardSignUpConstant.NewUser}</h1>
                                    <p class="requiredMandatory">{CleanerDashboardSignUpConstant.Mandatory}</p>
                                    <p class="required">{CleanerDashboardSignUpConstant.EnterOTP}</p>
                                    {this.state.elementOTP ? <span className="errorEmail">{this.state.errorsOTP}</span> : null}
                                    <ReusableTextBox className="OTPField"  onChange={this.handleOTP}  onKeyPress={e => this.onKeyPressOTP(e)} type="text" maxlength="6" />
                                    <div className="ForgotButtons">
                                    <ReusableButton onClick={this.handleAuthenticate} buttonText="Authenticate" className="SubmitField" />
                                     <ReusableButton onClick={this.handleCancelAuthenticate} buttonText={CleanerDashboardSignUpConstant.Cancel} className="CancelField" />
                                     </div>
                                    </div>
                                    </div>
                            : null
                            }
                </div>
            </div>
        )
    }
}

export default CleanerDashboardSignUp
